(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55],{

/***/ 89151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(9653);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blogs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(72167);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(44036);
var node_modules_classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/SafeAnchor.js
var SafeAnchor = __webpack_require__(48358);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PageItem.js


var _excluded = ["active", "disabled", "className", "style", "activeLabel", "children"],
    _excluded2 = ["children"];

/* eslint-disable react/no-multi-comp */



var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
var PageItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

  var Component = active || disabled ? 'span' : SafeAnchor/* default */.Z;
  return /*#__PURE__*/react.createElement("li", {
    ref: ref,
    style: style,
    className: node_modules_classnames_default()(className, 'page-item', {
      active: active,
      disabled: disabled
    })
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: "page-link",
    disabled: disabled
  }, props), children, active && activeLabel && /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
});
PageItem.defaultProps = defaultProps;
PageItem.displayName = 'PageItem';
/* harmony default export */ var esm_PageItem = (PageItem);

function createButton(name, defaultValue, label) {
  if (label === void 0) {
    label = name;
  }

  function Button(_ref2) {
    var children = _ref2.children,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded2);

    return /*#__PURE__*/react.createElement(PageItem, props, /*#__PURE__*/react.createElement("span", {
      "aria-hidden": "true"
    }, children || defaultValue), /*#__PURE__*/react.createElement("span", {
      className: "sr-only"
    }, label));
  }

  Button.displayName = name;
  return Button;
}

var First = createButton('First', '«');
var Prev = createButton('Prev', '‹', 'Previous');
var Ellipsis = createButton('Ellipsis', '…', 'More');
var Next = createButton('Next', '›');
var Last = createButton('Last', '»');
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Pagination.js


var Pagination_excluded = ["bsPrefix", "className", "children", "size"];





/**
 * @property {PageItem} Item
 * @property {PageItem} First
 * @property {PageItem} Prev
 * @property {PageItem} Ellipsis
 * @property {PageItem} Next
 * @property {PageItem} Last
 */
var Pagination = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, Pagination_excluded);

  var decoratedBsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'pagination');
  return /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: node_modules_classnames_default()(className, decoratedBsPrefix, size && decoratedBsPrefix + "-" + size)
  }), children);
});
Pagination.First = First;
Pagination.Prev = Prev;
Pagination.Ellipsis = Ellipsis;
Pagination.Item = esm_PageItem;
Pagination.Next = Next;
Pagination.Last = Last;
/* harmony default export */ var esm_Pagination = (Pagination);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js
var useWindowSize = __webpack_require__(98504);
;// CONCATENATED MODULE: ./src/app/components/navs/PaginationComp.tsx







var PaginationComp = function(props) {
    var ref = (0,react.useState)(props.pagination), pagination = ref[0], setPagination = ref[1], ref1 = (0,react.useState)(lodash_default().clamp(props.maxItems || 5, 5, 10)), maxItems = ref1[0], setMaxItems = ref1[1], ref2 = (0,useWindowSize/* default */.Z)(), windowWidth = ref2.width, classes = classnames_default()(props.className);
    (0,react.useEffect)(function() {
        if (windowWidth < 768 && maxItems > 3) {
            setMaxItems(3);
        } else {
            setMaxItems(lodash_default().clamp(props.maxItems || 5, 5, 10));
        }
    }, [
        windowWidth
    ]);
    (0,react.useEffect)(function() {
        setPagination(props.pagination);
    }, [
        props.pagination
    ]);
    var lastPage = Math.ceil(pagination.totalCount / pagination.rowsPerPage), currentPage = lodash_default().clamp(pagination.page, 1, lastPage), pagesArr = [];
    // The first page needs to always exist.
    pagesArr.push(1);
    // The pages in between 1 and lastPage.
    var start = lodash_default().clamp(Math.ceil(currentPage - maxItems / 2), 2, lastPage), end = lodash_default().clamp(start + maxItems, start + 1, lastPage);
    var dStartEnd = maxItems - (end - start);
    if (lodash_default().inRange(start, 1, lastPage) && lodash_default().inRange(end, 1, lastPage + 1)) {
        var _pagesArr;
        for(var i = 0; i < dStartEnd; i++){
            // Attempt to fill the remaining pages to fulfill maxItems
            var distFirstAndStart = start - 2, distEndAndLast = end - lastPage;
            if (distFirstAndStart && distFirstAndStart > distEndAndLast) {
                // There is more space at lower areas, expand it.
                start--;
            } else if (distEndAndLast && distEndAndLast > distFirstAndStart) {
                // There is more space at higher areas, expand it.
                end++;
            } else if (distEndAndLast === distFirstAndStart) {
                // There is equal space between lower and higher areas,
                // Ensure there's space and expand any of them with order from lower then higher.
                if (distFirstAndStart) {
                    start--;
                } else if (distEndAndLast) {
                    end++;
                }
            }
        }
        (_pagesArr = pagesArr).push.apply(_pagesArr, (0,_to_consumable_array/* default */.Z)(lodash_default().range(start, end, 1)));
    }
    // The last page also needs to exist.
    if (lastPage > 1) {
        pagesArr.push(lastPage);
    }
    /** Event handles */ var handleOnPageChanged = function(pageNo) {
        if (props.onPageChanged && typeof props.onPageChanged === "function") {
            return props.onPageChanged(pageNo);
        }
    }, onPrevClicked = function() {
        handleOnPageChanged(lodash_default().clamp(currentPage - 1, 1, lastPage));
    }, onNextClicked = function() {
        handleOnPageChanged(lodash_default().clamp(currentPage + 1, 1, lastPage));
    }, onPageClicked = function(evt) {
        var elem = evt.target, pageNo = parseInt(elem.dataset["page"]) || 0;
        handleOnPageChanged(lodash_default().clamp(pageNo, 1, lastPage));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_Pagination, {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Pagination.Prev, {
                onClick: onPrevClicked
            }),
            pagesArr.map(function(pageIdx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Pagination.Item, {
                    onClick: onPageClicked,
                    active: currentPage === pageIdx,
                    "data-page": pageIdx,
                    children: pageIdx
                }, pageIdx);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Pagination.Next, {
                onClick: onNextClicked
            })
        ]
    });
};
/* harmony default export */ var navs_PaginationComp = (PaginationComp);

;// CONCATENATED MODULE: ./pages/blogs/index.tsx















var LIMIT = 10;
var BlogsPage = function(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(lodash_default().clamp(Number(router.query.page) || 1, 1, 100)), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(props.blogs), blogs = ref2[0], setBlogs = ref2[1];
    var initialBlogs = props.blogs, popularBlogs = props.popularBlogs, totalCount = props.totalCount;
    var pagination = {
        page: currentPage,
        rowsPerPage: LIMIT,
        totalCount: totalCount
    };
    (0,react.useEffect)(function() {
        var page = Number(router.query.page) || 1;
        setCurrentPage(page);
    }, [
        router.query.page
    ]);
    (0,react.useEffect)(function() {
        var fetchBlogs = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var response, data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch("/api/blogs?page=".concat(currentPage, "&limit=").concat(LIMIT))
                            ];
                        case 2:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            data = _state.sent();
                            setBlogs(data.blogs);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            console.error("Error fetching blogs:", error);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchBlogs() {
                return _ref.apply(this, arguments);
            };
        }();
        if (currentPage > 1) {
            fetchBlogs();
        } else {
            setBlogs(initialBlogs);
        }
    }, [
        currentPage,
        initialBlogs
    ]);
    var onHandlePageChanged = function(page) {
        router.push({
            pathname: router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                page: page
            })
        }, undefined, {
            shallow: true
        });
    };
    /**
   * Meta contents
   */ var metaTitle = "Blogs | Heritage Counseling", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = "".concat(constants/* META_URL */.f1, "/blogs"), metaImage = "".concat(constants/* META_URL */.f1, "/logo.png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: "Blogs",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaImage
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaImage
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    }),
                    (blogs === null || blogs === void 0 ? void 0 : blogs.length) > 0 && blogs.map(function(blog) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(blog.schema)
                            }
                        }, blog.slug);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "blogs-page",
                "data-testid": "blogs-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blogs-list",
                        children: [
                            loading ? Array(LIMIT).fill(0).map(function(_, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "card blog-card",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-4 col-xl-3 img-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "skeleton-image animate-pulse",
                                                    style: {
                                                        height: "150px",
                                                        width: "150px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-8 col-xl-9",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "card-body",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "skeleton-title animate-pulse mb-3",
                                                            style: {
                                                                height: "24px",
                                                                width: "70%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "skeleton-text animate-pulse mb-2",
                                                            style: {
                                                                height: "16px",
                                                                width: "90%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "skeleton-text animate-pulse mb-2",
                                                            style: {
                                                                height: "16px",
                                                                width: "85%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "skeleton-text animate-pulse",
                                                            style: {
                                                                height: "14px",
                                                                width: "40%"
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }, idx);
                            }) : blogs.map(function(blog, idx) {
                                var ref;
                                var bodyText = (0,helpers/* sliceMetaDescription */.rJ)(blog.content.text, 210), publishedDateStr = (0,format/* default */.Z)(blog.createdAt, "PP");
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blogs/".concat(blog.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "card blog-card",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-4 col-xl-3 img-container",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "img-blog",
                                                        src: ((ref = blog.featuredImage) === null || ref === void 0 ? void 0 : ref.src) || "",
                                                        alt: blog.title,
                                                        height: 150,
                                                        width: 150
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-8 col-xl-9",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "card-body",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                className: "card-title",
                                                                children: blog.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "card-text",
                                                                children: bodyText
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "card-text",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                    className: "text-muted",
                                                                    children: [
                                                                        "Published on ",
                                                                        publishedDateStr
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, idx);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pagination-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navs_PaginationComp, {
                                    pagination: pagination,
                                    onPageChanged: onHandlePageChanged
                                })
                            })
                        ]
                    }),
                    (popularBlogs === null || popularBlogs === void 0 ? void 0 : popularBlogs.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "popular-blogs-list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "header text-muted",
                                children: "Popular Blogs"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: popularBlogs.map(function(blog, idx) {
                                    var ref;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blogs/".concat(blog.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "blog-link",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "img-blog",
                                                    src: ((ref = blog.featuredImage) === null || ref === void 0 ? void 0 : ref.src) || "",
                                                    alt: blog.title,
                                                    height: 70,
                                                    width: 70
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "blog-body",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: "blog-title",
                                                        children: blog.title
                                                    })
                                                })
                                            ]
                                        })
                                    }, idx);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var blogs = (BlogsPage);


/***/ }),

/***/ 75019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_PageLayoutV1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/static/images/layout/layout-hero-1440.jpg
/* harmony default export */ var layout_hero_1440 = ({"src":"/_next/static/media/layout-hero-1440.020fe420.jpg","height":318,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIFElFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCRLWMQhZDbvjERJi//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/app/hocs/PageLayoutV1.tsx






var PageLayoutV1 = function(param) {
    var title = param.title, tagline = param.tagline, children = param.children, fluidContainer = param.fluidContainer, noPadding = param.noPadding;
    var isContainerFluid = (0,helpers/* isNullOrUndefined */.le)(fluidContainer) ? false : fluidContainer, containerClasses = classnames_default()("layout-container", {
        container: !isContainerFluid,
        "no-padding": !!noPadding
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "layout-v1",
        "data-testid": "layout-v1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: layout_hero_1440.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "layout-hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: title || "Heritage Consulting"
                        }),
                        tagline ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tagline",
                            children: tagline
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClasses,
                children: children
            })
        ]
    });
};
/* harmony default export */ var hocs_PageLayoutV1 = (PageLayoutV1);


/***/ }),

/***/ 48358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _createChainedFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16833);


var _excluded = ["as", "disabled", "onKeyDown"];



function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var handleClick = function handleClick(event) {
    var href = props.href,
        onClick = props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (isTrivialHref(props.href)) {
    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
    // otherwise, the cursor incorrectly styled (except with role='button')

    props.href = props.href || '#';
  }

  if (disabled) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    ref: ref
  }, props, {
    onClick: handleClick,
    onKeyDown: (0,_createChainedFunction__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(handleKeyDown, onKeyDown)
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
/* harmony default export */ __webpack_exports__["Z"] = (SafeAnchor);

/***/ }),

/***/ 76792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; }
/* harmony export */ });
/* unused harmony exports createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var Consumer = ThemeContext.Consumer,
    Provider = ThemeContext.Provider;

function ThemeProvider(_ref) {
  var prefixes = _ref.prefixes,
      children = _ref.children;
  var copiedPrefixes = useMemo(function () {
    return _extends({}, prefixes);
  }, [prefixes]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: copiedPrefixes
  }, children);
}

function useBootstrapPrefix(prefix, defaultPrefix) {
  var prefixes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}

function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref

  var _opts = opts,
      prefix = _opts.prefix,
      _opts$forwardRefAs = _opts.forwardRefAs,
      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
  var Wrapped = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var props = _extends({}, _ref2);

    props[forwardRefAs] = ref;
    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      bsPrefix: bsPrefix
    }));
  });
  Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
  return Wrapped;
}


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 16833:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["Z"] = (createChainedFunction);

/***/ }),

/***/ 44036:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 98504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useRafState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45101);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76362);



var useWindowSize = function (initialWidth, initialHeight) {
    if (initialWidth === void 0) { initialWidth = Infinity; }
    if (initialHeight === void 0) { initialHeight = Infinity; }
    var _a = (0,_useRafState__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        width: _misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU ? window.innerWidth : initialWidth,
        height: _misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU ? window.innerHeight : initialHeight,
    }), state = _a[0], setState = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (_misc_util__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU) {
            var handler_1 = function () {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };
            (0,_misc_util__WEBPACK_IMPORTED_MODULE_2__.on)(window, 'resize', handler_1);
            return function () {
                (0,_misc_util__WEBPACK_IMPORTED_MODULE_2__/* .off */ .S1)(window, 'resize', handler_1);
            };
        }
    }, []);
    return state;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(89151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);